module.exports = __webpack_public_path__ + "img/hzm.1d14a38d.png";